<template>
  <div class="article_manage">
    <div v-show="!this.show">
      <div class="library_top" v-show="this.switch_classify">
        <div class="top_flex">
          <el-button :class="{green: type.class_id === ''}" @click="getAllVideo">全部</el-button>
          <el-button :key="index" :class="{green: type.class_id === value.class_id}" v-for="(value, index) in this.type.type_list" @click="set_class_id(value.class_id)">{{value.name}}</el-button>
        </div>
        <el-button class="add_category" @click="switch_btn">+</el-button>
      </div>


      <div class="data" v-show="this.switch_classify">
        <div class="data_top">
          <div class="left">
            <el-button @click="add_article">新增视频</el-button>
          </div>
          <div class="right">
            <el-select v-model="article.release_state" class="input_w174">
              <el-option label='已发布' :value=1></el-option>
              <el-option label='未发布' :value=0></el-option>
            </el-select>
            <el-select v-model="article.admin_id" class="input_w174">
              <el-option
                  v-for="item in account.list"
                  :key="item.admin_id"
                  :label="item.name"
                  :value="item.admin_id">
              </el-option>
            </el-select>
            <el-input v-model="article.title" placeholder="文章标题" class="input_w174"></el-input>
            <el-date-picker
                v-model="value1"
                type="daterange"
                range-separator="~"
                start-placeholder="开始日期"
                class="input_w240"
                clearable
                value-format="timestamp"
                end-placeholder="结束日期"
                :picker-options="pickerOptions">
            </el-date-picker>

            <el-button @click="search">搜索</el-button>
          </div>
        </div>
        <el-table
            id="table"
            :data="article.list"
            :header-cell-style="{background:'rgb(249,249,249)'}"
            ref="multipleTable"
            :row-style="{height: '80px'}"
            style="width: 99%;margin: 0 auto">
          <el-table-column
              label="视频预览"
              align="center"
              width="100">
            <template v-slot="scope">
              <img v-if="scope.row.image !== null" :src="scope.row.image" style="height: 60px;"/>
              <img v-else :src="scope.row.small_image" style="height: 60px;"/>
            </template>
          </el-table-column>
          <el-table-column
              align="left"
              prop="title"
              label="视频名称">
          </el-table-column>
          <el-table-column
              prop="class_name"
              width="100"
              label="类目">
          </el-table-column>
          <el-table-column
              prop="create_time"
              align="center"
              width="200"
              label="创建时间">
          </el-table-column>
          <el-table-column
              prop="release_state"
              align="center"
              width="100"
              label="发布状态">
            <template v-slot="scope">
              <span v-if="scope.row.release_state === 1">已发布</span>
              <span v-if="scope.row.release_state === 0">未发布</span>
            </template>>
          </el-table-column>
          <el-table-column
              prop="name"
              align="center"
              width="200"
              label="创建人">
          </el-table-column>
          <el-table-column
              prop="share_state"
              align="center"
              width="100"
              label="分享人数">
            <template v-slot="scope">
              <span v-if="scope.row.share_state === 1">已分享</span>
              <span v-if="scope.row.share_state === 0">未分享</span>
            </template>>
          </el-table-column>
          <el-table-column
              prop="share_state"
              align="center"
              width="100"
              label="分享次数">
            <template v-slot="scope">
              <span v-if="scope.row.share_state === 1">已分享</span>
              <span v-if="scope.row.share_state === 0">未分享</span>
            </template>>
          </el-table-column>
          <el-table-column
              prop="share_state"
              align="center"
              width="100"
              label="获客数量">
            <template v-slot="scope">
              <span v-if="scope.row.share_state === 1">已分享</span>
              <span v-if="scope.row.share_state === 0">未分享</span>
            </template>>
          </el-table-column>
          <el-table-column
              label="操作"
              width="100">
            <template v-slot="scope">
              <span class="tab_btn" @click="edit_video(scope.row)">编辑</span>
              <span v-show="scope.row.release_state === 0" class="tab_btn" style="color: rgba(249, 104, 104, 1);" @click="release(scope.row)">上线</span>
              <span v-show="scope.row.release_state === 1" class="tab_btn" style="color: rgba(249, 104, 104, 1);" @click="release(scope.row)">下线</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="btn_right">
          <div style="float: right">
            <el-pagination
                background
                layout="total,sizes, prev, pager, next"
                prev-text="上一页"
                next-text="下一页"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="article.pagesize"
                :pager-count='5'
                @size-change="artivle_modify_page"
                @current-change="artivle_switch_page"
                :total="article.article_num">
            </el-pagination>
          </div>

        </div>
      </div>
      <div class="add_category_div" v-show="!this.switch_classify">
        <div class="data_top">
          <div class="left">
            <el-button @click="new_category_open">新增分类</el-button>
          </div>
        </div>
        <el-table
            id="table1"
            :data="type.type_list"
            :header-cell-style="{background:'rgb(249,249,249)'}"
            ref="multipleTable"
            :row-style="{height: '40px'}"
            style="width: 99%;margin: 0 auto">
          <el-table-column
              align="left"
              prop="name"
              label="分类">
          </el-table-column>
          <el-table-column
              prop="is_show"
              width="100"
              align="center"
              label="前台显示">
            <template v-slot="scope">
              <span v-if="scope.row.is_show === 1">显示</span>
              <span v-if="scope.row.is_show === 0">隐藏</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="move"
              align="center"
              width="200"
              label="排序">
          </el-table-column>
          <el-table-column
              label="操作"
              width="100">
            <template v-slot="scope">
              <span class="tab_btn" @click="edit_category_open(scope.row.class_id, scope.row.name, scope.row.is_show)">编辑</span>
              <span class="tab_btn" @click="delVideoClass(scope.row.class_id)">删除</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="btn_right">
          <div style="float: right">
            <el-pagination
                background
                layout="total,sizes, prev, pager, next"
                prev-text="上一页"
                next-text="下一页"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="type.pagesize"
                :pager-count='5'
                @size-change="type_modify_page"
                @current-change="type_switch_page"
                :total="type.type_num">
            </el-pagination>
          </div>

        </div>
      </div>
    </div>


    <Dialog :show.sync="new_category_show" :name_width="new_category" class="dialog">
      <span slot="body">

        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="分类名称">
            <el-input v-model="form.name" class="input_w340"></el-input>
          </el-form-item>
          <el-form-item label="前台显示">
            <el-select v-model="form.is_show" class="input_w340">
              <el-option label='显示' value="1"></el-option>
              <el-option label='隐藏' value="0"></el-option>
            </el-select>
            <p class="tips">隐藏后小程序不显示</p>
          </el-form-item>

        </el-form>
      </span>
      <div slot="footer">
        <el-button type="primary"  @click="new_category_save">保 存</el-button>
        <el-button @click="new_category_close">取 消</el-button>
      </div>
    </Dialog>

    <Dialog :show.sync="edit_category_show" :name_width="edit_category" class="dialog">
      <span slot="body">

        <el-form ref="form" :model="this_type_form" label-width="80px">
          <el-form-item label="分类名称">
            <el-input v-model="this_type_form.name" class="input_w340"></el-input>
          </el-form-item>
          <el-form-item label="前台显示">
            <el-select v-model="this_type_form.is_show" class="input_w340">
              <el-option label='显示' value="1"></el-option>
              <el-option label='隐藏' value="0"></el-option>
            </el-select>
            <p class="tips">隐藏后小程序不显示</p>
          </el-form-item>

        </el-form>
      </span>
      <div slot="footer">
        <el-button type="primary"  @click="edit_category_save">保 存</el-button>
        <el-button @click="edit_category_close">取 消</el-button>
      </div>
    </Dialog>

    <div v-show="this.show">
      <div class="create_top" v-if="create_or_edit">
        <span class="create_title">创建视频</span>
        <el-button class="right create_save" @click="save_create_article">保存 创建视频</el-button>
      </div>
      <div class="create_top" v-if="!create_or_edit">
        <span class="create_title">编辑视频</span>
        <el-button class="right create_save" @click="save_edit_article">保存 编辑视频</el-button>
      </div>
      <div class="create_content">
        <div class="content_left">
          <img :src="video_img">
          <div class="poster_img_info">
            <div class="img_title">
              <p class="title_span">{{video_info.title}}</p>
              <p class="content_span">{{video_info.abstract}}</p>
            </div>
            <div class="img_icon">
              <div>
                <svg t="1617788200517" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5057" width="40" height="40"><path d="M884.875894 423.143253 646.970506 423.143253c92.185562-340.464205-63.516616-357.853247-63.516616-357.853247-65.993017 0-52.312436 52.182476-57.3031 60.881602 0 166.502152-176.849824 296.971645-176.849824 296.971645l0 472.171899c0 46.607504 63.516616 63.393819 88.433098 63.393819l357.452111 0c33.641191 0 61.036122-88.224344 61.036122-88.224344 88.434122-300.70569 88.434122-390.177444 88.434122-390.177444C944.657442 418.179195 884.875894 423.143253 884.875894 423.143253L884.875894 423.143253 884.875894 423.143253zM884.875894 423.143253" p-id="5058" fill="#ffffff"></path><path d="M251.671415 423.299819 109.214912 423.299819c-29.420053 0-29.873378 28.89612-29.873378 28.89612l29.420053 476.202703c0 30.309306 30.361495 30.309306 30.361495 30.309306L262.420223 958.707948c25.686009 0 25.458835-20.049638 25.458835-20.049638L287.879058 459.411271C287.879058 422.837284 251.671415 423.299819 251.671415 423.299819L251.671415 423.299819 251.671415 423.299819zM251.671415 423.299819" p-id="5059" fill="#ffffff"></path></svg>
                <p>365</p>
              </div>
              <div style="margin-top: 20px">
                <svg t="1617788970419" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5988" width="40" height="40"><path d="M872 520.41304356v295.74782577a75.40434756 75.40434756 0 0 1-75.40434756 75.40434844H227.40434756A75.40434756 75.40434756 0 0 1 152 816.16086933V246.96956533c0-41.63478223 33.76956533-75.40434756 75.40434756-75.40434756h271.91739199a31.30434756 31.30434756 0 1 0 0-62.60869599H227.40434756A138.01304356 138.01304356 0 0 0 89.39130401 246.96956533v569.191304A138.01304356 138.01304356 0 0 0 227.40434756 954.17391289h569.19130488a138.01304356 138.01304356 0 0 0 138.01304355-138.01304356v-295.74782577a31.30434756 31.30434756 0 1 0-62.60869599 0z" p-id="5989" fill="#ffffff"></path><path d="M707.65217422 242.35217422a187.82608711 187.82608711 0 0 0-187.82608711 187.82608623v196.66956533a31.30434756 31.30434756 0 1 0 62.60869511 0V430.17826045a125.21739112 125.21739112 0 0 1 125.217392-125.21739111h185.24347822a35.21739112 35.21739112 0 0 0 27-57.83478223L780.63043467 81.01739112a31.30434756 31.30434756 0 0 0-48.01304355 40.2260871l101.54347821 121.108696H707.65217422z" p-id="5990" fill="#ffffff"></path></svg>
                <p>365</p>
              </div>
            </div>
          </div>
        </div>
        <div class="content_right">
          <el-form ref="article" :inline="true" :model="video_info">
            <el-form-item label="视频标题">
              <el-input v-model="video_info.title" placeholder="请输入内容" class="input_w292"></el-input>
              <p class="tips1">视频名称尽量间断，言简意赅，可以同名</p>
            </el-form-item>
            <el-form-item label="前台展示">
              <el-select v-model="video_info.release_state" class="input_w340">
                <el-option label='显示' :value=1></el-option>
                <el-option label='隐藏' :value=0></el-option>
              </el-select>
              <p class="tips1">未发布状态，前台商家无法查看此视频</p>
            </el-form-item>
            <el-form-item label="视频主图" class="video_img" :class="{upload: video_img_show}">
              <el-upload
                  v-if="create_or_edit"
                  ref="uploads"
                  action="upload"
                  :http-request="addVideo"
                  list-type="picture-card"
                  :auto-upload="false"
                  :before-upload="beforeUpload"
                  :on-change="imghandleChange"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-upload
                  v-if="!create_or_edit"
                  ref="edit_uploads"
                  action="upload"
                  :http-request="editVideo"
                  list-type="picture-card"
                  :auto-upload="false"
                  :limit="1"
                  :file-list="listArr"
                  :before-upload="beforeUpload1"
                  :on-change="imghandleChange"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>
              <p class="tips1">视频缩略图可以根据实际情况进行调整，固定宽度</p>
            </el-form-item>
            <el-form-item label="视频内容" :class="{upload: video_show}">
              <el-upload
                  v-if="create_or_edit"
                  ref="uploads"
                  action="upload"
                  :http-request="editVideo"
                  list-type="picture-card"
                  :auto-upload="false"
                  accept=".mp4"
                  :before-upload="beforeUpload"
                  :on-change="videohandleChange"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove1">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-upload
                  v-if="!create_or_edit"
                  ref="uploads_video"
                  action="upload"
                  :http-request="editVideo"
                  list-type="picture-card"
                  :auto-upload="false"
                  accept=".mp4"
                  :before-upload="beforeUpload_video"
                  :on-change="videohandleChange"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove1">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>
              <p class="tips1">最大支持50M；支持MP4格式</p>
            </el-form-item>
            <el-form-item label="视频内容">

              <el-input type="textarea" v-model="video_info.abstract" placeholder="选填，摘要会在视频分享视显示，帮助读者快速了解内容，如不填写则默认为空" class="input_w657"></el-input>
            </el-form-item>



          </el-form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Dialog from "components/content/dialog/Dialog";
import WangEditor from "components/content/wangeditor/WangEditor";

import {getVideoClassList, addVideoClass, delVideoClass, editVideoClass, getVideoList, addVideo, editVideo, videoRelease} from 'network/hk_admin_video'
import {getAdminList} from 'network/hk_admin_account'
import E from "wangeditor";

let fd = new FormData()

export default {
  name: "VideoManage",
  components: {
    Dialog
  },
  data() {
    return {
      type: {
        // 文章类别每页数量
        pagesize: 10,
        page: 1,
        // 类别数量
        type_num: 0,
        // 类别列表
        type_list: [],
        class_id: '',
      },
      article: {
        list: [],
        pagesize: 10,
        page: 1,
        article_num: 0,
        class_id: null,
        title: '',
        search_time: [],
        release_state: 1,
        admin_id: 2,
      },
      create_article: {

      },
      video_info: {
        video_id: '',
        title: '',
        release_state: 1,
        abstract: '',
        class_id: '',
        fileList: [],
        image: null,
        video: null,
        small_image:''
      },
      video_img: '',
      video_img_show: false,
      video_show: false,

      account: {
        admin_id: 2,
        list: []
      },
      source: {
        list: [{
          value: '1',
          label: '全部状态'
        },{
          value: '2',
          label: '文章'
        },{
          value: '3',
          label: '名片'
        },{
          value: '4',
          label: '海报'
        },{
          value: '5',
          label: '表单'
        },{
          value: '6',
          label: '视频'
        },],
        value: '全部状态'
      },
      source1: {
        list: [{
          value: '1',
          label: '全部账号'
        },{
          value: '2',
          label: '文章'
        },{
          value: '3',
          label: '名片'
        },{
          value: '4',
          label: '海报'
        },{
          value: '5',
          label: '表单'
        },{
          value: '6',
          label: '视频'
        },],
        value: '全部账号'
      },
      show: false,


      // 类别列表
      type_list: [],
      // 默认类别
      default_type: '',


      listArr: [
        {
          name: '',
          url: ''
        },
      ],


      input1: '',

      phoneEditor: '',
      name: '',

      more_show: false,



      textarea: '',
      dialogImageUrl: '',
      dialogVisible: false,
      // 新建分类
      new_category: {
        name: '新建分类',
        width: '500px'
      },
      new_category_show: false,
      // 编辑分类
      edit_category: {
        name: '编辑分类',
        width: '500px'
      },
      edit_category_show: false,
      edit_article_show: false,


      select_members_show: false,
      switch_classify: true,
      input: '',
      value1: '',
      value: '',
      value2: '',
      form: {
        name: '',
        is_show: '1'
      },
      this_type_form: {
        class_id: '',
        name: '',
        is_show: '1'
      },
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', [new Date(), new Date()]);
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', [date, new Date()]);
          }
        },{
          text: '本周',
          onClick(picker) {
            var nowTemp = new Date();//当前时间
            var oneDayLong = 24*60*60*1000 ;//一天的毫秒数
            var c_time = nowTemp.getTime() ;//当前时间的毫秒时间
            var c_day = nowTemp.getDay()||7;//当前时间的星期几
            var m_time = c_time - (c_day-1)*oneDayLong;//当前周一的毫秒时间
            var monday = new Date(m_time);//设置周一时间对象
            var m_year = monday.getFullYear();
            var m_month = monday.getMonth()+1;
            var m_date = monday.getDate();
            var start =  m_year+'-'+m_month+'-'+m_date//周一的年月日
            const end = new Date();
            // const start = new Date(new Date().getMonth(), 0);
            picker.$emit('pick', [start, end]);
          }
        },{
          text: '本月',
          onClick(picker) {
            var date = new Date(), y = date.getFullYear(), m = date.getMonth();
            var firstDay = new Date(y, m, 1);
            const end = new Date();
            const start = new Date(new Date().getMonth(), 0);
            picker.$emit('pick', [firstDay, end]);
          }
        },{
          text: '本年',
          onClick(picker) {
            const end = new Date();
            const start = new Date(new Date().getFullYear(), 0);
            picker.$emit('pick', [start, end]);
          }
        },{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近半年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  created() {
    this.getVideoClassAllList()
    this.getVideoList(this.article.pagesize, this.article.page, this.article.title, this.article.class_id, this.article.search_time, this.article.release_state)
    this.getAdminList()
  },
  computed: {
    create_or_edit() {
      var length = Object.keys(this.video_info).length
      if (length === 6) {
        return true
      }
    },


  },
  watch: {
    video_info: {
      handler() {
        if (this.video_info.small_image !== '') {
          this.listArr[0].url = this.video_info.small_image
          this.video_img_show = true
        }
      }
    }
  },

  methods: {
    edit_video(video) {
      this.show = true
      this.video_info = video
      this.video_img = this.video_info.small_image
    },
    release(video) {
      let release_state = null
      if (video.release_state === 1) {
        release_state = 0
      } else {
        release_state = 1
      }
      this.videoRelease(video.video_id, release_state)
    },


    // 获取用户列表
    getAdminList() {
      getAdminList().then(res => {
        if (res.code === 10000) {
          this.account.list = res.result
        } else if (res.code === 10001 && res.message === '请重新登录') {
          this.clearToken()
        }
      })
    },

    getAllVideo() {
      this.type.class_id = ''
      this.article.class_id = ''
      this.getAllVideoList(this.article.pagesize, this.article.page)
    },

    add_article() {
      this.show = true
    },
    // 保存 创建文章
    save_create_article() {
      // this.$refs.uploads.submit();
      this.show = false
    },
    save_edit_article() {



      fd.append('video_id', this.video_info.video_id)
      fd.append('title', this.video_info.title)
      fd.append('abstract', this.video_info.abstract)
      fd.append('release_state', this.video_info.release_state)
      fd.append('class_id', this.video_info.class_id)
      editVideo(fd).then(res => {
        console.log(res)
      })
      this.$refs.edit_uploads.submit();
      this.$refs.uploads_video.submit();
      this.show = false
    },
    more_open() {
      this.more_show = true
    },
    more_close() {
      this.more_show = false
    },
    handleRemove() {
      this.video_img_show = false
      this.video_img = ''
    },
    handleRemove1() {
      this.video_show = false
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    imghandleChange (file) {
      this.video_info.image = file
      console.log(file)
      this.video_img = file.url
      this.video_img_show = true
      // this.video_info.fileList.push(fileList)
    },
    videohandleChange (file) {
      this.video_info.video = file
      this.video_show = true

    },
    beforeUpload (file) {
      console.log(this.video_info.fileList)
      let fd = new FormData()
      fd.append('title', this.video_info.title)
      fd.append('abstract', this.video_info.abstract)
      fd.append('release_state', this.video_info.release_state)
      fd.append('class_id', this.video_info.class_id)
      fd.append('video', this.video_info.video.raw)
      if (this.video_info.image != null) {
        fd.append('image', this.video_info.image.raw)
      }

      addVideo(fd).then(res => {
        console.log(res)
      })
      return true
    },
    beforeUpload1 (file) {
      console.log(file)
      fd.append('image', file)
    },
    beforeUpload_video (file) {
      console.log(file)
      fd.append('video', file)
    },


    getTableLength() {
      return this.type.type_list.length
    },

    switch_btn() {
      this.getVideoClassList(this.type.pagesize, this.type.page)
      this.switch_classify = false
    },
    edit_article(article) {
      // this.$emit('update:show', true)
      this.show = true
      this.$emit('article', article)
    },

    // 新建分类
    new_category_open() {
      this.new_category_show = true;
    },
    new_category_close() {
      this.new_category_show = false;
    },
    new_category_save() {
      this.addVideoClass(this.form.name, this.form.is_show)
      this.getVideoClassList(this.type.pagesize, this.type.page)
      this.form.name = ''
      this.new_category_show = false;
    },
    // 编辑分类
    edit_category_open(class_id, name, is_show) {
      this.this_type_form.class_id = class_id
      this.this_type_form.name = name
      this.this_type_form.is_show = is_show.toString()
      this.edit_category_show = true;
    },
    edit_category_close() {
      this.edit_category_show = false;
    },
    edit_category_save() {
      this.editVideoClass(this.this_type_form.class_id, this.this_type_form.name, this.this_type_form.is_show)
      this.getVideoClassList(this.type.pagesize, this.type.page)
      this.edit_category_show = false;
    },

    click() {
      this.$emit('update:show', true)
    },
    search() {
      this.article.search_time = []

      this.article.search_time.push(this.value1[0]/1000)
      this.article.search_time.push(this.value1[1]/1000)

      this.article.search_time = JSON.stringify(this.article.search_time)

      if( this.article.search_time=='[null,null]'){
        this.article.search_time=[]
      }
      console.log(typeof this.article.search_time)

      this.getVideoList(this.article.pagesize, this.article.page, this.article.title, this.article.class_id, this.article.admin_id, this.article.search_time, this.article.release_state)
    },

    // 切换类别
    set_class_id(class_id) {
      this.type.class_id = class_id
      this.article.class_id = class_id
      this.getVideoList(this.article.pagesize, this.article.page, this.article.title, this.article.class_id, this.article.admin_id, this.article.search_time, this.article.release_state)
    },
    // 获取视频列表
    getVideoList(pagesize, page, title, class_id, admin_id, search_time, release_state) {
      getVideoList(pagesize, page, title, class_id, admin_id, search_time, release_state).then(res => {
        if (res.code === 10000) {
          this.article.list = res.result.video.data
          this.article.article_num = res.result.video.total
        } else if (res.code === 10001 && res.message === '请重新登录') {
          this.clearToken()
        }
      })
    },
    getAllVideoList(pagesize, page) {
      getVideoList(pagesize, page).then(res => {
        if (res.code === 10000) {
          this.article.list = res.result.video.data
          this.article.article_num = res.result.video.total
        } else if (res.code === 10001 && res.message === '请重新登录') {
          this.clearToken()
        }
      })
    },
    // 获取文章类别列表
    getVideoClassList(pagesize, page) {
      getVideoClassList(pagesize, page).then(res => {
        if (res.code === 10000) {
          this.type.type_list = res.result.data
          this.type.type_num = res.result.total
        } else if (res.code === 10001 && res.message === '请重新登录') {
          this.clearToken()
        }
      })
    },
    // 获取全部类别列表
    getVideoClassAllList() {
      getVideoClassList().then(res => {
        if (res.code === 10000) {
          this.type.type_list = res.result
        } else if (res.code === 10001 && res.message === '请重新登录') {
          this.clearToken()
        }
      })
    },
    // 类别列表 每页几条数据
    type_modify_page(val) {
      this.type.pagesize = val
      this.getVideoClassList(this.type.pagesize, this.type.page)
    },
    // 类别列表 切换页码
    type_switch_page(val) {
      this.type.page = val
      this.getVideoClassList(this.type.pagesize, this.type.page)
    },

    // 类别列表 每页几条数据
    artivle_modify_page(val) {
      this.article.pagesize = val
      this.getVideoList(this.article.pagesize, this.article.title, this.article.class_id, this.article.search_time)
    },
    // 类别列表 切换页码
    artivle_switch_page(val) {
      this.article.page = val
      this.getVideoList(this.article.pagesize, this.article.title, this.article.class_id, this.article.search_time)
    },
    // 修改视频类别
    editVideoClass(class_id, name, is_show) {
      editVideoClass(class_id, name, is_show).then(res => {
        if (res.code === 10000) {
          this.$message(res.message);
        } else if (res.code === 10001 && res.message === '请重新登录') {
          this.clearToken()
        }
      })
    },
    // 删除视频类别
    delVideoClass(class_id) {
      delVideoClass(class_id).then(res => {
        if (res.code === 10000) {
          this.$message(res.message);
        } else if (res.code === 10001 && res.message === '请重新登录') {
          this.clearToken()
        }
      })
      this.getVideoClassList(this.type.pagesize, this.type.page)
    },
    // 添加视频类别
    addVideoClass(name, is_show) {
      addVideoClass(name, is_show).then(res => {
        if (res.code === 10000) {
          this.$message(res.message);
        } else if (res.code === 10001 && res.message === '请重新登录') {
          this.clearToken()
        }
      })
    },
    // 发布状态
    videoRelease(video_id, release_state) {
      videoRelease(video_id, release_state).then(res => {
        if (res.code === 10000) {
          this.getAllVideoList(this.article.pagesize, this.article.page)
        } else if (res.code === 10001 && res.message === '请重新登录') {
          this.clearToken()
        }
      })
    },

    addVideo(data) {
      addVideo(data).then(res => {
        if (res.code === 10000) {

        } else if (res.code === 10001 && res.message === '请重新登录') {
          this.clearToken()
        }
      })
    },
    editVideo(data) {
      editVideo(data).then(res => {
        if (res.code === 10000) {

        } else if (res.code === 10001 && res.message === '请重新登录') {
          this.clearToken()
        }
      })
    },


  },
}
</script>

<style scoped>
.article_manage {
  position: absolute;
  /*width: 88%;*/
  min-width: 958px;
  padding: 0;
  padding-bottom: 10px;
  margin-top: 60px;
  padding-right: 10px;
  right: 0;
  left: 160px;
  height: auto;
  overflow: hidden;
}

.library_top {
  width: 100%;
  background-color: #FFFFFF;
  padding-bottom: 10px;
}


.top_flex {
  width: 90%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-content: center;
  position: relative;
}
/deep/ .top_flex .el-button {
  border-radius: 2px;
  height: 32px;
  line-height: 0px;
  padding: 10px 15px;
  background: rgb(242,242,242);
  border: none;
  color: rgba(56, 56, 56, 1);
  margin: 10px 10px 0px 10px;
}
.add_category {
  position: absolute;
  border-radius: 2px;
  width: 30px;
  height: 30px;
  line-height: 0px;
  padding: 0;
  background: rgb(242,242,242);
  border: none;
  color: rgba(56, 56, 56, 1);
  right: 30px;
  top: 10px;
}
.green {
  background: rgb(200,232,205)!important;
  color: rgb(39,165,56)!important;
}
.data {
  background: #fff;
  margin-top: 15px;
}
.add_category_div {
  height: auto;
  background: #fff;
  margin-top: 15px;
}
.data_top {
  width: 100%;
  height: 55px;
}
.left {
  float: left;
  margin-top: 10px;
  margin-left: 10px;
}
.right {
  float: right;
  margin-top: 10px;
  margin-right: 10px;
}
.btn_right {
  height: 50px;
  margin-top: 15px;
  margin-right: 10px;
}
.input_w174 {
  width: 174px;
  margin-right: 5px;
}
.input_w240 {
  width: 240px;
  margin-right: 5px;
}
.right>.el-button {
  width: 50px;
  height: 32px;
  padding: 0;
  background: rgb(39,165,56);
  color: #fff;
  border: none;
}
.right>.el-button:hover {
  background: rgb(24,134,39);
}

.left>.el-button {
  width: 80px;
  height: 32px;
  padding: 0;
  background: rgb(39,165,56);
  color: #fff;
  border: none;
}
.left>.el-button:hover {
  background: rgb(24,134,39);
}

.create_top {
  width: 100%;
  height: 50px;
  background-color: #FFFFFF;
  margin-top: 15px;
}
.create_title {
  font-size: 16px;
  color: rgba(56, 56, 56, 1);
  line-height: 50px;
  margin-left: 15px;
}
.right {
  float: right;
  margin-top: 10px;
  margin-right: 10px;
}
.create_save {
  border-radius: 2px;
  width: 120px;
  height: 36px;
  background-color: rgba(39, 165, 56, 1);
  padding: 0;
  color: #FFFFFF;
  margin-top: 7px;
  border: none;
}
.create_save:hover {
  background-color: rgba(24,134,39, 1);
  color: #FFFFFF;
}
.create_content {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin-top: 15px;
}
.content_left {
  width: 375px;
  min-width: 375px;
  background: #000;
  display: inline-block;
  margin: 0;
  height: auto;
  box-shadow: 0 1px 4px rgb(0 0 0 / 4%);
  opacity: 1;
  border-radius: 4px;
  position: relative;
}
.content_left img {
  width: 100%;

}
.content_left .poster_img_info {
  position: absolute;
  width: 100%;
  bottom: 0;
  padding: 45px 25px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
}
.content_left .poster_img_info .img_title {
  width: 225px;
}
.content_left .poster_img_info .img_icon p {
  font-size: 12px;
  color: #fff;
  margin-left: 10px;
}

.content_left .poster_img_info .img_title p {
  color: #fff;
}
.content_left .poster_img_info .title_span {
  font-size: 14px;
  font-weight: 700;
  margin-top: 78px;
}
.content_left .poster_img_info .content_span {
  font-size: 12px;
  margin-top: 10px;
}



.content_right .font_color {
  cursor: pointer;
  font-size: 14px;
}

/deep/ .create_content .content_right .el-form-item__label{
  float: none;
}
/deep/ .create_content .content_right .el-form-item__content {
  margin-left: 0;
}

.content_right {
  width: 100%;
  height: auto;
  background: #FFFFFF;
  margin-left: 20px;
  padding: 50px 700px 50px 50px;
}

.content_right .add {
  float: right;
  color: rgb(39,165,56);
  cursor: pointer;
}
.tips1 {
  font-size: 12px;
  color: rgba(166, 166, 166, 1);
}
/deep/ .el-upload--picture-card {
  width: 80px;
  height: 80px;
  line-height: 80px;
  background: rgb(242,242,242);
  border: none;
  border-radius: 1px;
}
/deep/ .el-input__inner {
  border-radius: 2px;
}

/deep/ .el-upload--picture-card i {
  font-size: 18px;
  position: relative;
  left: 28px;
  top: -9px;
}
/deep/ .el-textarea__inner {
  height: 100%;
  padding: 0;
  border-radius: 2px;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 80px;
  height: 80px;
}
/deep/ .el-input__inner:focus {
  border: 1px solid rgb(39,165,56);
}
/deep/ .el-textarea__inner:focus {
  border: 1px solid rgb(39,165,56);
}
.input_w292 {
  width: 292px;
}
/deep/ .el-form--inline .el-form-item__label {
  display: block;
}
/deep/ .el-form-item__label {
  text-align: left;
}
/deep/ .el-form--inline .el-form-item {
  margin-right: 25px;
}
.el-upload--picture-card i {
  left: 0;
  top: 0;
}
/deep/ .video_img {
  width: 292px;
}
.input_w657 {
  width: 657px;
}
/deep/ .upload .el-upload--picture-card {
  display: none;
}

#table img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}


</style>
<style>

.el-date-editor .el-range-separator {
line-height: 23px;
}

.el-input__icon {
  line-height: 30px;
}
.el-date-editor .el-range__icon {
  line-height: 25px;
}
.el-date-editor .el-range__close-icon {
  line-height: 25px;
}

.el-select .el-input.is-focus .el-input__inner {
  border-color: rgb(39,165,56);
}
.el-select .el-input__inner:focus {
  border-color: rgb(39,165,56);
}
.el-select .el-input__inner:hover {
  border-color: rgb(39,165,56);
}
.el-range-editor.is-active, .el-range-editor.is-active:hover {
  border-color: rgb(39,165,56);
}
.el-table th>.cell {
  color: rgba(56, 56, 56, 1);
}
.el-select-dropdown__item.selected {
  color: rgb(39,165,56);
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: rgb(39,165,56);
}
.btn-prev {
  width: 64px;
  height: 32px;
}
.btn-next {
  width: 64px;
  height: 32px;
}
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
  background-color: #fff;
  border: 1px solid rgb(207,207,207);
}
.el-pagination__sizes .el-input .el-input__inner:hover {
  border-color: rgb(39,165,56);
}
</style>